var YouLi = YouLi ? YouLi : {};
YouLi.CreditCardPaymentForm = YouLi.CreditCardPaymentForm ? YouLi.CreditCardPaymentForm : {};
YouLi.CreditCardPaymentForm.Square = YouLi.CreditCardPaymentForm.Square ? YouLi.CreditCardPaymentForm.Square : {};

(function (YouLi) {
    (function (CreditCardPaymentForm) {
        (function (Square) {
            // This function tokenizes a payment method.
            // The ‘error’ thrown from this function denotes a failed tokenization,
            // which is due to buyer error (such as an expired card). It is up to the
            // developer to handle the error and provide the buyer the chance to fix
            // their mistakes.
            YouLi.CreditCardPaymentForm.Square.SquareTokenize = function (paymentMethod) {
                return paymentMethod.tokenize()
                    .then((tokenResult) => {
                        if (tokenResult.status === 'OK') {
                            return tokenResult.token;
                        } else {
                            let errorMessage = `Tokenization failed-status: ${tokenResult.status}`;
                            if (tokenResult.errors) {
                                errorMessage += ` and errors: ${JSON.stringify(
                                    tokenResult.errors
                                )}`;
                            }
                            throw new Error(errorMessage);
                        }
                    })
                    .catch((error) => {
                        throw new Error(error.message);
                    })
            }

            YouLi.CreditCardPaymentForm.Square.InitialiseSquare = function () {

                // Create and initialize a Square payment form object

                if (!window.Square) {
                    throw new Error('Square.js failed to load properly');
                }
                const payments = window.Square.payments(YouLi.CreditCardPaymentForm.SquareApplicationId, YouLi.CreditCardPaymentForm.SquareLocationId);

                const cardStyles = {
                    input: {
                        fontSize: '16px',
                        fontFamily: 'Arial, Helvetica, sans-serif'
                    }
                };

                payments.card({
                    style: cardStyles
                }).then((card) => {
                    YouLi.CreditCardPaymentForm.SquarePaymentCardObject = card;

                    return YouLi.CreditCardPaymentForm.SquarePaymentCardObject.attach('#card-container');
                }).catch((e) => {
                    console.error('Initializing Card failed', e);

                });

            };

            YouLi.CreditCardPaymentForm.Square.SquareHandlePaymentMethodSubmission = function () {

                YouLi.CreditCardPaymentForm.ClearErrorInModal();
                $(".content-trip-paymentdetails-error").addClass("hidden");

                YouLi.CreditCardPaymentForm.Square.SquareTokenize(YouLi.CreditCardPaymentForm.SquarePaymentCardObject)
                    .then((token) => {
                        return YouLi.CreditCardPaymentForm.CheckForOverpayment()
                            .then(() => {

                                YouLi.CreditCardPaymentForm.MakePaymentFunction(token, "square");

                            }).catch((errorObject) => {
                                console.error('Error:', errorObject.message);

                                YouLi.Common.UI.HideButtonLoading($("#p-creditcard"));

                                if (!errorObject.errorHandled) {
                                    YouLi.CreditCardPaymentForm.OnPageErrorHandlerFunction("", moment());
                                }
                            });
                    }).catch((e) => {
                    YouLi.Common.UI.HideButtonLoading($("#p-creditcard"));

                    $(".content-trip-paymentdetails-error").removeClass("hidden");

                    $("#GenericPaymentErrorMessage").text(e.message).removeClass("hidden");
                });
            }
        }(YouLi.CreditCardPaymentForm.Square ? YouLi.CreditCardPaymentForm.Square : {}));
    }(YouLi.CreditCardPaymentForm ? YouLi.CreditCardPaymentForm : {}));
}(YouLi ? YouLi : {}));